import PropTypes from "prop-types";
import "./Tooltip.css";

export default function Tooltip({
  children,
  tooltipHeader,
  tooltipBody,
  position,
}) {
  return (
    <div className="tooltip-trigger">
      {children}
      <div className={`tooltip tooltip-${position}`}>
        <div className="tooltip-header">{tooltipHeader}</div>
        <div className="tooltip-body">{tooltipBody}</div>
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipHeader: PropTypes.string,
  tooltipBody: PropTypes.string,
  position: PropTypes.oneOf(["top", "right", "bottom", "left"]),
};
